import { ActionIcon, Group, Table } from '@mantine/core';
import { Rozet } from './Rozet';

/**
 * SOLUK SATIR (P1 · P1-a · P1-b — Kapsam §20.3b).
 *
 * **ALT KALEM SATIR İÇİ GİRİLİR.** Ayrım bir YARGI değil, YAPISALDIR:
 * *kaydın kendi sayfası olabiliyor mu?* Olabiliyorsa bağımsız kayıttır
 * (olay · iş izni · eğitim · ekipman) → ayrı sayfa; olamıyorsa alt kalemdir
 * (görev tanımı · risk maddesi · izin katılımcısı) → satır içi.
 *
 * ⚠️ **SOLUK SATIR HER ZAMAN LİSTENİN SONUNDADIR** — ortada belirmez;
 * kaydedilen satır üstüne oturur ve altında yenisi doğar.
 *
 * ⚠️ **"EKLE" DÜĞMESİ YOKTUR** ve eklenmez: satır zaten oradadır. On beş
 * kalem girecek uzman **elini klavyeden kaldırmaz**.
 *
 * ⚠️ **BOŞ LİSTE DURUMUNU DA BU SATIR ÇÖZER:** hiç kayıt yoksa ekranda
 * **yalnız soluk satır** durur. *"Henüz kayıt yok"* kutusu YAZILMAZ —
 * kullanıcıya ne yapacağını **anlatmak** yerine yapabileceği yeri
 * **gösteririz**.
 *
 * ⚠️ **P1-b — ALAN ÇOKSA SATIR GENİŞLER, ayrı sayfaya KAÇILMAZ:** çağıran
 * `ikinciKatman` verirse satır altına ikinci bir hücre satırı açılır. Kaçmak
 * P1'i fiilen iptal ederdi.
 *
 * ⚠️ **P1-a ŞERHİ — LİSTE SAYFALANIYORSA SOLUK SATIR TEK BAŞINA YETMEZ**
 * (Tur 4½ / E1, 03.09.2026; Kapsam §20.3b). Satır listenin **sonunda**
 * durduğu için sayfalanan bir listede **son sayfanın sonuna** düşer: on yedi
 * kayıtta bile ekranın altında kaybolur, gerçek bir envanterde kullanıcı onu
 * **hiç görmez.** Ürün sahibi ekipman envanterinde tam olarak bunu yaşadı ve
 * *"ekleyemiyorum"* dedi — **satır oradaydı, ulaşılamıyordu.**
 *
 * Kural: **sayfalanan listede üstte bir tetikleyici düğme bulunur**; basılınca
 * aynı soluk satır listenin **başında** açılır ve sayfalamadan bağımsız
 * çalışır. ⚠️ **İki soluk satır aynı anda ÇİZİLMEZ** — çağıran satırın
 * KONUMUNU değiştirir, ikinci bir satır doğurmaz; ikisi birden görünseydi
 * kullanıcı hangisine yazacağını bilemez ve iki taslak arasında veri
 * kaybederdi.
 *
 * Şerhi mekanizmaya çeviren yol **bilinçli olarak açılmadı:** bileşen kendi
 * başına sayfalandığını bilemez ve *"düğmeyi ben çizeyim"* diyen bir bileşen,
 * düğmenin yerini (P2: başlık satırı) ve etiketini de sahiplenirdi. Kural
 * burada YAZILI, uygulaması çağırandadır — **tarama** ile denetlenir.
 *
 * **03.09.2026 TARAMASI — TEK VAKA EKİPMANDI.** Sayfalanan altı liste
 * (Aksiyonlar · Uygunsuzluklar · Yükümlülük · Kullanıcılar · Periyodik
 * görevler · Ekipman) tarandı: soluk satır taşıyan **yalnız Ekipman**;
 * ilk ikisinde zaten üstte düğme var, kalan üçünde **listeden kayıt
 * açılmaz** (yükümlülük kalemi kilitli ürün verisi · hesap kişiyle doğar ·
 * periyodik görev üretilir, açılmaz). Soluk satır taşıyan diğer ekranlar
 * (görev kuralları · risk maddeleri · olay alt kalemleri · kişi kartı)
 * **sayfalanmıyor** — o gün sayfalanırlarsa bu şerhi devralırlar.
 */
export function SolukSatir({
  dokunuldu,
  kaydedilebilir,
  onKaydet,
  onVazgec,
  kaydediliyor,
  taslakDurumu,
  kayitKimligi,
  onEtkinlestir,
  kolonSayisi,
  ikinciKatman,
  children,
  testId = 'soluk-satir',
}: {
  /**
   * ✏️ **YÜZEY DÜRÜSTLÜĞÜ TURU (R11 revizyonu + C1 dersi):** kaydedilmemiş
   * içerik artık başka satıra geçince YERİNDE soluk kalır; soluk satır bu
   * yüzden İKİ anlama gelebilir — *"kaydedilmedi"* (taslak bekliyor) ve
   * *"kaydediliyor"* (istek sürüyor). İkisi aynı opaklıkta görünür; ayrım
   * YÜZEYDE rozetle ve `data-taslak` işaretiyle kurulur.
   *
   * Verilmezse (mevcut çağıranlar) rozet çizilmez ve davranış değişmez.
   */
  taslakDurumu?: 'kaydedilmedi' | null;
  /** Birden çok taslak satır yan yana durabildiği için satırın kaydı. */
  kayitKimligi?: string;
  /** Satıra odaklanıldığında (tık · klavye) çağıran onu ETKİN yapar. */
  onEtkinlestir?: () => void;
  /** Kullanıcı herhangi bir alana dokundu mu — opaklığın TEK ekseni. */
  dokunuldu: boolean;
  kaydedilebilir: boolean;
  onKaydet: () => void;
  /**
   * **P1-c — VAZGEÇ HER ZAMAN VARDIR; TEK DÜĞME İKİ DAVRANIŞTIR** (Kapsam
   * §20.3b; ilk kod karşılığı madde 220 / R11): soluk satırda *"satırı
   * boşalt"*, düzenlemede *"değişikliği at"*. Hangisi olduğunu ÇAĞIRAN
   * bilir; bileşen yalnız düğmeyi kaydet düğmesinin YANINA koyar (ikinci
   * katmanın dibine gömülmüş bir Vazgeç, kullanıcının aradığı yerde değildi).
   * Verilmezse düğme çizilmez — mevcut çağıranlar etkilenmez.
   */
  onVazgec?: () => void;
  kaydediliyor?: boolean;
  kolonSayisi: number;
  ikinciKatman?: React.ReactNode;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  // İki hâl AYNI opaklıkta görünür; ayrım bu işarette ve rozette (C1 dersi).
  const taslakIsareti = kaydediliyor ? 'kaydediliyor' : (taslakDurumu ?? 'yok');
  return (
    <>
      <Table.Tr
        data-testid={testId}
        // Testler ve görsel dil turu aynı işareti okur: "soluk mu?"
        data-soluk={dokunuldu ? 'hayir' : 'evet'}
        data-taslak={taslakIsareti}
        data-kayit-id={kayitKimligi}
        style={{ opacity: dokunuldu ? 1 : 0.55 }}
        onFocusCapture={onEtkinlestir}
        onKeyDown={(olay) => {
          if (olay.key === 'Enter' && kaydedilebilir && !kaydediliyor) {
            olay.preventDefault();
            onKaydet();
          }
        }}
      >
        {children}
        <Table.Td>
          <Group gap={4} wrap="nowrap">
            {taslakDurumu !== undefined && taslakIsareti !== 'yok' && (
              <Rozet anlam="dikkat" testId={`${testId}-taslak`}>
                {taslakIsareti === 'kaydediliyor' ? 'kaydediliyor…' : 'kaydedilmedi'}
              </Rozet>
            )}
            <ActionIcon
              variant="light"
              size="sm"
              aria-label="Satırı kaydet"
              disabled={!kaydedilebilir || kaydediliyor}
              loading={kaydediliyor}
              onClick={onKaydet}
              data-testid={`${testId}-kaydet`}
            >
              ✓
            </ActionIcon>
            {onVazgec && (
              <ActionIcon
                variant="subtle"
                size="sm"
                aria-label="Vazgeç"
                // Soluk satırda boşaltılacak bir şey yoksa düğme pasiftir;
                // düzenlemede her zaman açıktır (değişiklik olmasa da satırı
                // kapatır — kullanıcıyı düzenleme modunda hapsetmez).
                disabled={kaydediliyor}
                onClick={onVazgec}
                data-testid={`${testId}-vazgec`}
              >
                ✕
              </ActionIcon>
            )}
          </Group>
        </Table.Td>
      </Table.Tr>
      {ikinciKatman && (
        <Table.Tr
          data-testid={`${testId}-ikinci-katman`}
          data-kayit-id={kayitKimligi}
          style={{ opacity: dokunuldu ? 1 : 0.55 }}
          onFocusCapture={onEtkinlestir}
        >
          <Table.Td colSpan={kolonSayisi + 1}>{ikinciKatman}</Table.Td>
        </Table.Tr>
      )}
    </>
  );
}
